import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [],
  imports: [FlexLayoutModule, CommonModule],
  providers: [],
  bootstrap: [],
  exports: [FlexLayoutModule, CommonModule],
})
export class SharedModule {}
